import { render } from "./verify-detail.vue?vue&type=template&id=5c95bba9&scoped=true"
import script from "./verify-detail.vue?vue&type=script&lang=js"
export * from "./verify-detail.vue?vue&type=script&lang=js"

import "./verify-detail.vue?vue&type=style&index=0&id=5c95bba9&scoped=true&lang=css"

import exportComponent from "E:\\Projects\\YCTECH\\ycform\\trunk\\ycform-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c95bba9"]])

export default __exports__